import { scope } from '../../constants';

export const GET_TRADE = `${scope}GET_TRADE`;
export const SET_TRADE = `${scope}SET_TRADE`;
